import { Injectable } from "@angular/core"; 
import { Subject } from "rxjs";
import { Reset } from "../models/reset";

@Injectable({ 
    providedIn: "root" 
}) 

export class ResetService {
    public static Crops: string = "Crops";
    public static Programs: string = "Programs";
    public static EvaluationZones: string = "EvaluationZones";
    public static Marker: string = "Marker";
    
    private resetData = new Subject<any>();
    resetData$ = this.resetData.asObservable();

    resetDataCommunicate(reset : Reset) {
        this.resetData.next(reset);
    }
}